import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=6d6ffd6e&"
import script from "./GatewayDetail.vue?vue&type=script&lang=js&"
export * from "./GatewayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports